import React from "react";
import Avatar from "./Avatar";

interface AvatarGroupProps {
  avatars: Array<{
    src?: string;
    alt?: string;
    name?: string;
  }>;
  max?: number;
  size?: "sm" | "md" | "lg";
}

const AvatarGroup: React.FC<AvatarGroupProps> = ({
  avatars,
  max = 3,
  size = "md",
}) => {
  const visibleAvatars = avatars.slice(0, max);
  const remainingCount = avatars.length - max;

  return (
    <div className="flex -space-x-2">
      {visibleAvatars.map((avatar, index) => (
        <div key={index} className="ring-2 ring-white rounded-full">
          <Avatar
            src={avatar.src}
            alt={avatar.alt}
            name={avatar.name}
            size={size}
          />
        </div>
      ))}
      {remainingCount > 0 && (
        <div className="ring-2 ring-white rounded-full">
          <div
            className={`${
              size === "sm"
                ? "h-6 w-6 text-xs"
                : size === "md"
                  ? "h-8 w-8 text-sm"
                  : "h-10 w-10 text-base"
            } rounded-full bg-gray-400 flex items-center justify-center text-white font-medium`}
          >
            +{remainingCount}
          </div>
        </div>
      )}
    </div>
  );
};

export default AvatarGroup;
